import { ReactComponent as Mill } from "../rsc/mill.svg"
import { ReactComponent as Chevron } from "../rsc/chevron.svg"
import { ReactComponent as Truck } from "../rsc/truck_2.svg"
import { ReactComponent as Close } from "../rsc/red_close.svg"
import "./CardChooseTransport.scss"
import { useTranslation } from "react-i18next"

type Props = {
    onClick?: () => void
}

export function CardChooseNotTransport({onClick}: Props) {
    const { t } = useTranslation();
    return (
        <div onClick={onClick} className="bg-yellow-gradient boxShadow" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding:"40px", gap:"25px" }}>
            <Mill />
            <div style={{ display: "flex", alignItems:"center", textAlign:"center" }}>
                <p className="text-extra-big" style={{fontWeight:"700", margin:"0 20px 0 0"}}>{t('price_at_mill')}</p>
                <Chevron />
            </div>
            <div style={{ display: "flex", gap:"10px" }}>
                <div style={{ position: "relative" }}>
                    <Truck style={{opacity:0.5}}/>
                    <Close style={{ position: "absolute", left:-16, top:-16, height:"32px", width:"32px" }} />
                </div>
                <p className="text-medium-plus" style={{fontWeight:"700", maxWidth:"200px"}}>{t('transport_not_included')}</p>
            </div>
        </div>
    )
}